export const handleAddPlusToPhone = (phone) => {
    if (phone.startsWith("+") || phone.startsWith("00")) {
        return phone;
    }
    return `+${phone}`;
};
//# sourceMappingURL=handleAddPlusToPhone.js.map